import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { FinancialInstitution } from '@store/core/core.interface';
import { TranslateModule } from '@ngx-translate/core';
import { IdFormatPipe } from '@core/pipes/id-format.pipe';
import { PbbImgErrorDirective } from '@core/directives/pbb-img-error.directive';
import { NgClass, UpperCasePipe } from '@angular/common';

@Component({
    selector: 'pbb-address-suggestion',
    templateUrl: './address-suggestion.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, PbbImgErrorDirective, IdFormatPipe, TranslateModule, UpperCasePipe]
})
export class AddressSuggestionComponent {
  @Input() financialInstitution?: FinancialInstitution;
  @Input() hideSuggestion? = false;
}
